'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/throttleTime';
import React, {Component} from 'react';

/**
 *
 * @param {Component} WrappedComponent
 * @param {Number} [throttleTime=66] Throttle time in milliseconds
 * @return {Component}
 */
export function responsiveContent(WrappedComponent, throttleTime = 66) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        viewWidth: global.window.innerWidth,
      };
    }

    render() {
      return <WrappedComponent viewWidth={this.state.viewWidth} {...this.props} />;
    }

    componentDidMount() {
      this.sub = Observable.fromEvent(global.window, 'resize')
        .throttleTime(throttleTime, void 0, {leading: true, trailing: true})
        .map(() => global.window.innerWidth || global.document.documentElement.clientWidth || global.document.body.clientWidth)
        .distinctUntilChanged()
        .delay(0)
        .subscribe(viewWidth => this.setState({viewWidth}))
    }

    componentWillUnmount() {
      this.sub && this.sub.unsubscribe();
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/responsive-components/ResponsiveContentHOC.js